import { render, staticRenderFns } from "./IbDrawer.vue?vue&type=template&id=2eba73b6&scoped=true"
import script from "./IbDrawer.vue?vue&type=script&lang=js"
export * from "./IbDrawer.vue?vue&type=script&lang=js"
import style0 from "./IbDrawer.vue?vue&type=style&index=0&id=2eba73b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba73b6",
  null
  
)

export default component.exports